import type { FunctionComponent, ReactElement } from 'react';

import { Icons } from './iconNames';
import { IconSvg, type IconSvgProps } from './IconSvg';

export interface IconProps extends IconSvgProps {
  icon: keyof Icons;
}

export const Icon: FunctionComponent<IconProps> = (props): ReactElement => <IconSvg {...props} />;
